import { InjectionToken, Provider } from '@angular/core';

export interface SharedDomainConfig {
  appName?: string;
  apiBaseUrl?: string;
}

export const DEFAULT_SHARED_DOMAIN_CONFIG: SharedDomainConfig = {
  appName: 'App',
  apiBaseUrl: '',
};

export const SHARED_DOMAIN_CONFIG = new InjectionToken<SharedDomainConfig>('SHARED_DOMAIN_CONFIG', {
  providedIn: 'root',
  factory: () => DEFAULT_SHARED_DOMAIN_CONFIG,
});

export function provideSharedDomainConfig(config: SharedDomainConfig): Provider {
  return { provide: SHARED_DOMAIN_CONFIG, useValue: config };
}

export function provideDefaultSharedDomainConfig(
  config: Partial<SharedDomainConfig> = {}
): Provider {
  return {
    provide: SHARED_DOMAIN_CONFIG,
    useValue: {
      ...DEFAULT_SHARED_DOMAIN_CONFIG,
      ...config,
    },
  };
}
